import {useInvertedSurface} from '@hconnect/common/styles'
import {KpiScore} from '@hconnect/uikit/src/lib2'
import {Box, Stack} from '@mui/material'
import {eventStatusContrastIcons, eventStatusIcons} from '@widgets/common-shift-event'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {TaskStatusCountDto, TaskStatus} from '../types'

type Props = {
  data: TaskStatusCountDto[] | undefined
  showLoader?: boolean
}

const taskStatuses = Object.values(TaskStatus)

export const TasksStatusesSummary = ({data, showLoader}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const inverted = useInvertedSurface()
  const statusIcons = inverted ? eventStatusContrastIcons : eventStatusIcons

  const statuses = taskStatuses.map((key) => ({
    key,
    label: t(`task.status.${key}`),
    value: data?.find(({status}) => status === key)?.count || 0
  }))

  return (
    <Stack
      direction="row"
      spacing={2}
      flexWrap="wrap"
      useFlexGap
      data-test-id="tasks-statuses-summary"
    >
      {statuses?.map(({key, label, value}) => (
        <Box key={key} sx={{minWidth: 100}}>
          <KpiScore
            label={label}
            value={value}
            size="M"
            transparentIconLabelSxProp={{whiteSpace: 'nowrap'}}
            contrastMode={inverted}
            labelIcon={statusIcons[key as string]}
            showValueLoader={showLoader}
            data-test-id={`status-${key}`}
          />
        </Box>
      ))}
    </Stack>
  )
}
